(ns minorodata.sql-console-modal.events
  (:require [minorodata.app.handlers :refer [reg-event-db reg-event-fx dispatch]]
            [minorodata.utils :as utils]
            [minorodata.sql-console.model :refer [->sql-editor]]

            [minorodata.transform.model :refer [->unsaved-transform]]
            [re-posh.core :as re-posh]))

(reg-event-db
 :sql-console-modal.events/toggle-modal
 (fn [db [status]]
   (when (or @(re-posh/subscribe [:users.subs/has-permissions? :sql-browser/read])
             (false? status))
     (assoc-in db [:sql-console-modal/state :open?] status))))


(defn add-unsaved-transform [transform-id form-state]
  (let [{:keys [cron] :as form-data} form-state
        transform       (assoc form-data
                               :id transform-id
                               :schedule-spec {:cron cron})
        transform-model (->unsaved-transform transform)]
    [:unsaved-transform/add transform-model]))


(defn maybe-update-transform-id-in-tab-data [old-id transform]
  (fn [tab-data]
    (let [metadata     (:metadata tab-data)
          transform-id (or (:id transform)
                           (:transform-id transform))]

      (if (and (= "transform" (:type metadata))
               (= old-id (:transform-id metadata)))
        (-> tab-data
            (assoc-in [:metadata :transform-id] transform-id)
            (assoc-in [:metadata :updated-at] (or (:updated-at transform)
                                                  (:created-at transform))))

        tab-data))))


(reg-event-fx
 :sql-console-modal.events/update-transform-ids
 (fn [_ [old-transform-id transform]]
   (let [tab-data @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])]
     {:dispatch-n [[:sql-editor/update (->sql-editor
                                        {:tab-data-container (mapv (maybe-update-transform-id-in-tab-data old-transform-id transform) tab-data)})]]})))


(reg-event-fx
 :sql-console-modal.events/save-transform
 (fn [_ [{:keys [tab-data silent]}]]
   (let [{:keys [metadata code]} tab-data
         {:keys [transform-id group-id environment-id tab-id ignore-parser]} metadata

         transform @(re-posh/subscribe [:transform/pull [:transform/id transform-id] '[* {:transform/tags [*]}]])

         transform (update-keys
                    transform
                    (comp keyword name))

         transform (cond-> transform
                     ignore-parser (assoc :ignore-parser ignore-parser))

         form-data (-> transform
                       (select-keys [:status :is-temp :is-full :ignore-parser :input-tables :output-tables :name :description :tags :schedule-spec])
                       (update :tags (fn [tags] (mapv :transform-tag/value tags))))
         form-data (assoc form-data :command code :id transform-id)]

     {:dispatch-n [(add-unsaved-transform transform-id form-data)
                   [:transform.events/upsert-transform {:group-id       group-id
                                                        :transform      form-data
                                                        :environment-id environment-id
                                                        :upsert-event   :environments.api/update-transform
                                                        :tab-id         tab-id
                                                        :on-success (when-not silent
                                                                      (fn []
                                                                        (js/setTimeout
                                                                         (fn []
                                                                           (dispatch [:sql-console-modal.events/update-metadata-for-tab
                                                                                      (:tab-id metadata)
                                                                                      #(dissoc % :ignore-parser :transform-parsing-error)]))
                                                                         50)

                                                                        (js/setTimeout
                                                                         (fn []
                                                                           (dispatch [:sql-console-modal.events/update-opened-at tab-data]))
                                                                         100)))}]]})))

(reg-event-fx
 :sql-console-modal.events/save-transform-and-close
 (fn [_ [params]]
   (let [tab-count @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-count])]
     {:dispatch-n [(if (> tab-count 1)
                     [:sql-console.events/delete-tab (:idx params)]
                     [:sql-console.events/reset-tab (:idx params)])
                   [:sql-console-modal.events/save-transform (assoc params :silent true)]]})))



(reg-event-fx
 :sql-console-modal.events/update-opened-at
 (fn [_ [tab-data]]
   (let [{:keys [metadata]} tab-data
         {:keys [tab-id]} metadata

         new-ts        (.toISOString (js/Date.))

         all-tab-data @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])
         tab-filter-fn (fn [tab]
                         (= tab-id (get-in tab [:metadata :tab-id])))

         matching-tab-index (utils/find-index tab-filter-fn all-tab-data)

         new-tab-data (into []
                            (assoc-in all-tab-data [matching-tab-index :metadata :opened-at] new-ts))]

     {:dispatch-n [[:sql-editor/update (->sql-editor {:tab-data-container new-tab-data})]]})))


(reg-event-fx
 :sql-console-modal.events/update-metadata-for-tab
 (fn [_ [tab-id metadata-fn]]
   (let [all-tab-data @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])
         tab-filter-fn (fn [tab]
                         (= tab-id (get-in tab [:metadata :tab-id])))

         matching-tab-index (utils/find-index tab-filter-fn all-tab-data)

         new-tab-data (into []
                            (update-in all-tab-data [matching-tab-index :metadata] metadata-fn))]

     {:dispatch [:sql-editor/update (->sql-editor {:tab-data-container new-tab-data})]})))

(reg-event-fx
 :sql-console-modal.events/update-tab
 (fn [_ [tab-id data-fn]]
   (let [all-tab-data @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])
         tab-filter-fn (fn [tab]
                         (= tab-id (get-in tab [:metadata :tab-id])))

         matching-tab-index (utils/find-index tab-filter-fn all-tab-data)

         new-tab-data (into []
                            (update all-tab-data matching-tab-index data-fn))]

     {:dispatch [:sql-editor/update (->sql-editor {:tab-data-container new-tab-data})]})))


(reg-event-fx
 :sql-console-modal.events/update-code-to-latest-version
 (fn [_ []]
   (let [tab       (or @(re-posh/subscribe [:sql-editor/prop :sql-editor/current-tab]) 0)
         tdc       @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])

         tab-data  (nth tdc tab {})
         metadata   (:metadata tab-data)
         transform-id (:transform-id metadata)

         transform @(re-posh/subscribe [:transform/pull [:transform/id transform-id]])

         transform (update-keys
                    transform
                    (comp keyword name))

         code-when-tab-was-opened (:command metadata)
         code-in-console-tab      @(re-posh/subscribe [:sql-editor/prop :sql-editor/code])
         latest-code-from-api     (:command transform)

         ;;  keep updated code if there is no change in bases
         code (if (= code-when-tab-was-opened latest-code-from-api)
                code-in-console-tab
                latest-code-from-api)

         name (:name transform)

         updated-at (:updated-at transform)
         now-ts  (.toISOString (js/Date.))]

     {:dispatch-n [[:sql-console-modal.events/update-tab
                    (:tab-id metadata)
                    (fn [tab]
                      (-> tab
                          (assoc :code code)
                          (update :metadata
                                  (fn [metadata]
                                    (assoc metadata
                                           :name       name
                                           :opened-at  now-ts
                                           :touched-at now-ts
                                           :updated-at updated-at
                                           :command    code)))))]
                   [:sql-console.events/save-tabs-to-local-storage]]})))


(defn matching-tab? [transform tab]
  (let [tab-meta (:metadata tab)]
    (and
     (= "transform" (:type tab-meta))
     (= (:transform/master-id transform)
        (:master-id tab-meta))
     (= (:transform/environment-id transform)
        (:environment-id tab-meta)))))

;; If transform is already opened in one of the tabs, try switching to that tab
;; instead of opening new tabs.

(reg-event-fx
 :sql-console-modal.events/open-transform
 (fn [_ [transform-id params]]
   (let [tab-data           @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])
         transform          @(re-posh/subscribe [:transform/pull [:transform/id transform-id]])
         tab-filter-fn      (partial matching-tab? transform)
         matching-tab       (utils/find-first tab-filter-fn tab-data)
         matching-tab-index (utils/find-index tab-filter-fn tab-data)
         new-tab-index      (or matching-tab-index 0)]

     {:dispatch-n
      (if matching-tab
        [[:sql-console-modal.events/toggle-modal true]
         [:sql-editor/update (->sql-editor {:current-tab new-tab-index})]
         (when (:preview params)
           [:sql-console-modal.events/update-metadata-for-tab
            (get-in matching-tab [:metadata :tab-id])
            #(dissoc % :preview)])]

        [[:sql-console-modal.events/open-transform-in-new-tab transform-id params]])})))

(reg-event-fx
 :sql-console-modal.events/open-transform-in-new-tab
 (fn [_ [transform-id {:keys [preview replace-tab-idx]}]]
   (let [tab-data @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])

         transform @(re-posh/subscribe [:transform/pull [:transform/id transform-id]])

         environment-id (:transform/environment-id transform)

         new-data {:code                (:transform/command transform)
                   :data                []
                   :metadata            (cond-> {:tab-id         (str (random-uuid))
                                                 :type           "transform"
                                                 :opened-at      (.toISOString (js/Date.))
                                                 :environment-id environment-id
                                                 :group-id       (:transform/group-id transform)
                                                 :updated-at     (or (:transform/updated-at transform)
                                                                     (:transform/created-at transform))
                                                 :output-tables  (:transform/output-tables transform)
                                                 :name           (:transform/name transform)
                                                 :master-id      (:transform/master-id transform)
                                                 :transform-id   (or (:transform/transform-id transform)
                                                                     (:transform/id transform))
                                                 :command        (:transform/command transform)}
                                          preview (assoc :preview true))
                   :results-tab         0
                   :results-tab-configs {}}


         preview-tab-idx (utils/find-index (fn [{{:keys [preview type]} :metadata}]
                                             (and (= "transform" type) preview))
                                           tab-data)

         new-tab-data (cond->> tab-data
                        replace-tab-idx
                        (utils/drop-nth replace-tab-idx)

                        (and preview preview-tab-idx)
                        (utils/drop-nth preview-tab-idx)

                        :always
                        (concat [new-data]))]

     {:dispatch-n
      [[:environments.api/get-latest-version-by-master-id-preview {:environment-id (get-in new-data [:metadata :environment-id])
                                                                   :master-id (get-in new-data [:metadata :master-id])
                                                                   :old-transform-id (get-in new-data [:metadata :transform-id])}]
       [:sql-editor/update (->sql-editor (merge
                                          new-data
                                          {:current-tab        0
                                           :tab-data-container (into [] new-tab-data)
                                           :tab-count          (count new-tab-data)}))]
       [:sql-console-modal.events/toggle-modal true]
       [:sql-console.events/set-editor-content (:code new-data)]]})))


(reg-event-fx
 :sql-console-modal.events/open-transforms
 (fn [_ [transform-ids]]
   (let [tab-data @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])

         new-data (->> transform-ids
                       (keep
                        (fn [id]
                          (let [transform      @(re-posh/subscribe [:transform/pull [:transform/id id]])
                                environment-id (:transform/environment-id transform)]
                            (when (not (some #(matching-tab? transform %) tab-data))
                              {:code                (:transform/command transform)
                               :data                []
                               :metadata            {:tab-id         (str (random-uuid))
                                                     :type           "transform"
                                                     :opened-at      (.toISOString (js/Date.))
                                                     :environment-id environment-id
                                                     :group-id       (:transform/group-id transform)
                                                     :updated-at     (or (:transform/updated-at transform)
                                                                         (:transform/created-at transform))
                                                     :output-tables  (:transform/output-tables transform)
                                                     :name           (:transform/name transform)
                                                     :master-id      (:transform/master-id transform)
                                                     :transform-id   (or (:transform/transform-id transform)
                                                                         (:transform/id transform))
                                                     :command        (:transform/command transform)}
                               :results-tab         0
                               :results-tab-configs {}})))))

         new-tab-data (->> tab-data
                           (concat new-data))
         active-tab (first new-tab-data)]

     {:dispatch-n
      [[:environments.api/get-latest-version-by-master-id-preview {:environment-id   (get-in active-tab [:metadata :environment-id])
                                                                   :master-id        (get-in active-tab [:metadata :master-id])
                                                                   :old-transform-id (get-in active-tab [:metadata :transform-id])}]
       [:sql-editor/update (->sql-editor {:current-tab        0
                                          :tab-data-container (into [] new-tab-data)
                                          :tab-count          (count new-tab-data)})]
       [:sql-console-modal.events/toggle-modal true]
       [:sql-console.events/set-editor-content (:code active-tab)]]})))


(reg-event-fx
 :sql-console-modal.events/open-new-tab-with-code
 (fn [_ [code]]
   (let [tab-data @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])

         new-data {:code                code
                   :data                []
                   :metadata            {:tab-id (str (random-uuid))
                                         :type "snippet"
                                         :opened-at (.toISOString (js/Date.))}
                   :results-tab         0
                   :results-tab-configs {}}

         new-tab-data (concat [new-data] tab-data)]

     {:dispatch-n
      [[:sql-editor/update (->sql-editor {:current-tab 0
                                          :tab-data-container (into [] new-tab-data)
                                          :tab-count          (count new-tab-data)})]
       [:sql-console-modal.events/toggle-modal true]
       [:sql-console.events/set-editor-content (:code new-data)]]})))

(reg-event-fx
 :sql-console-modal.events/set-editor-content
 (fn [_ [code]]
   (let [tab-data    @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])
         current-tab @(re-posh/subscribe [:sql-editor/prop :sql-editor/current-tab])]
     (dispatch [:sql-console.events/set-editor-content code])

     (dispatch [:sql-editor/update
                (->sql-editor {:code code
                               :tab-data-container (assoc-in tab-data [current-tab :code] code)})]))))

(defn reorder-array [arr from to]
  (let [item           (nth arr from)
        [before after] (split-at (cond-> to
                                   (> to from) inc)
                                 arr)]
    (vec (concat (remove #(= item %) before)
                 [item]
                 (remove #(= item %) after)))))

(reg-event-fx
 :sql-console-modal.events/reorder-tabs
 (fn [_ [from-idx to-idx]]
   (when (not= from-idx to-idx)
     (let [tab-data @(re-posh/subscribe [:sql-editor/prop :sql-editor/tab-data-container])
           tab-data (reorder-array tab-data from-idx to-idx)]
       {:dispatch [:sql-editor/update (->sql-editor {:tab-data-container tab-data
                                                     :current-tab        to-idx})]}))))

(reg-event-db
 :sql-console-modal.events/toggle-unit-tests-modal
 (fn [db [status]]
   (cond-> (assoc-in db [:app/modals :transform-unit-tests :open?] status)
     (not status)
     (update-in [:app/modals :transform-unit-tests] dissoc :output-tables))))

(reg-event-db
 :sql-console-modal.events/set-unit-tests-transform
 (fn [db [transform]]
   (assoc-in db [:app/modals :transform-unit-tests :transform] transform)))

(reg-event-db
 :sql-console-modal.events/set-unit-tests-output-tables
 (fn [db [output-tables]]
   (assoc-in db [:app/modals :transform-unit-tests :output-tables] output-tables)))

(reg-event-db
 :sql-console-modal.events/toggle-db-copy-modal
 (fn [db [status]]
   (assoc-in db [:app/modals :db-copy :open?] status)))

(reg-event-db
 :sql-console-modal.events/set-db-copy-env
 (fn [db [env-id]]
   (assoc-in db [:db-copy-modal/selected-environment-id] env-id)))
